import { render } from "./IconServer.vue.js?vue&type=template&id=50be6082!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconServer.vue?vue&type=template&id=50be6082"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__